const passwordhasMoreThanEightCharacters = (password) => password.length >= 8;

const passwordHasNumber = (password) => {
  const re = /\d/;
  return re.test(password);
};

const passwordHasUpperCaseAndLowerCase = (password) => {
  const re = /(?=[a-z]+.*[A-Z]+|[A-Z].*[a-z]+)/;
  return re.test(password);
};

const passwordHasSequenceNumbers = (password) => {
  if (password.length == 0) return false;
  const re = /(?=0123+|1234+|2345+|3456+|4567+|5678+|6789+)/;
  return !re.test(password);
};

const passwordsEquals = (password, confirmPassword) => {
  return password === confirmPassword;
};

export {
  passwordhasMoreThanEightCharacters,
  passwordHasNumber,
  passwordHasUpperCaseAndLowerCase,
  passwordHasSequenceNumbers,
  passwordsEquals,
};
